export default {
	TABLE_TITLE: 'Grid entries',
	GRID_ENTRY_ADDED: 'Grid entry added',
	GRID_ENTRY_EDITED: 'Grid entry edited',
	GRID_ENTRY_DELETED: 'Grid entry deleted',
};
